export default __webpack_public_path__ + "711e59234aff4d4f6bfa340b55a70212.svg";